// Registro central: qual período tem dados prontos pra virar horário.
//
// Pra adicionar um período novo:
//   1. Crie ./period<N>.js seguindo exatamente o formato de DEMO-template.js.
//   2. Importe e registre aqui embaixo.
// Um período sem entrada aqui simplesmente não tem dados ainda — o app mostra um aviso
// ("ainda não temos os dados desse período") em vez de quebrar. Não é preciso preencher
// os 12 de uma vez.
import period1 from "./period1.js";
import period2 from "./period2.js";
import period3 from "./period3.js";
import period4 from "./period4.js";
import period5 from "./period5.js";
import period6 from "./period6.js";
import period7 from "./period7.js";
import period8 from "./period8.js";

export const PERIODS = {
  1: period1,
  2: period2,
  3: period3,
  4: period4,
  5: period5,
  6: period6,
  7: period7,
  8: period8
};

export function getPeriodDataset(number) {
  return PERIODS[number] || null;
}

export function listAvailablePeriods() {
  return Object.keys(PERIODS)
    .map(Number)
    .sort((a, b) => a - b);
}
